<section class="mainBanner innerPage" *ngIf="!isThankYouPage">
    <div class="container" *ngIf="storDetails">
        <div class="detailPageHead" *ngIf="storDetails.displayName">
            <h1>{{storDetails.displayName  | textSpliteByHyphenPipe:'-':
                0}}</h1>
            <div class="wrapLocationRating">
                <span class="banLocation">
                    <span>{{storDetails.displayName  | textSpliteByHyphenPipe:'-':
                        1}}</span>
                </span>
                <div class="rating" *ngIf="storDetails && storDetails.reviews.length > 0">
                    <!-- <star-rating [value]="storDetails.reviews[0].averate_rating" [totalstars]="5" checkedcolor="#F2C94C"
                        uncheckedcolor="lightgray" size="24px" [readonly]="true" #starrating>
                    </star-rating> -->
                    <div class="stars-rate">
                        <div class="main-star" style="position: relative;">
                            <span class="fa fa-star" [ngClass]="{'checked' : storDetails.reviews[0].averate_rating >= 1}"></span>
                            <span class="fa fa-star fa-solid fa-star-half" *ngIf="(storDetails.reviews[0].averate_rating > 0 && storDetails.reviews[0].averate_rating < 1)" [ngClass]="{'checked' : (storDetails.reviews[0].averate_rating > 0 && storDetails.reviews[0].averate_rating < 1) , 'fa-star-half' : (storDetails.reviews[0].averate_rating > 0 && storDetails.reviews[0].averate_rating < 1) }"></span>
                        </div>
                        <div class="main-star" style="position: relative;">
                            <span class="fa fa-star"  [ngClass]="{'checked' : storDetails.reviews[0].averate_rating >= 2}"></span>
                            <span class="fa fa-star fa-solid fa-star-half" *ngIf="(storDetails.reviews[0].averate_rating > 1 && storDetails.reviews[0].averate_rating < 2)" [ngClass]="{'checked' : (storDetails.reviews[0].averate_rating > 1 && storDetails.reviews[0].averate_rating < 2) , 'fa-star-half' : (storDetails.reviews[0].averate_rating > 1 && storDetails.reviews[0].averate_rating < 2) }"></span>
                        </div>
                        <div class="main-star" style="position: relative;">
                            <span class="fa fa-star"  [ngClass]="{'checked' : storDetails.reviews[0].averate_rating >= 3}"></span>
                            <span class="fa fa-star fa-solid fa-star-half" *ngIf="(storDetails.reviews[0].averate_rating > 2 && storDetails.reviews[0].averate_rating < 3)" [ngClass]="{'checked' : (storDetails.reviews[0].averate_rating > 2 && storDetails.reviews[0].averate_rating < 3) , 'fa-star-half' : (storDetails.reviews[0].averate_rating > 2 && storDetails.reviews[0].averate_rating < 3) }"></span>
                        </div>
                        <div class="main-star" style="position: relative;">
                            <span class="fa fa-star"  [ngClass]="{'checked' : storDetails.reviews[0].averate_rating >= 4}"></span>
                            <span class="fa fa-star fa-solid fa-star-half" *ngIf="(storDetails.reviews[0].averate_rating > 3 && storDetails.reviews[0].averate_rating < 4)" [ngClass]="{'checked' : (storDetails.reviews[0].averate_rating > 3 && storDetails.reviews[0].averate_rating < 4) , 'fa-star-half' : (storDetails.reviews[0].averate_rating > 3 && storDetails.reviews[0].averate_rating < 4) }"></span>
                         </div>
                        <div class="main-star" style="position: relative;">
                            <span class="fa fa-star" [ngClass]="{'checked' : storDetails.reviews[0].averate_rating == 5}"></span>
                            <span class="fa fa-star fa-solid fa-star-half" *ngIf="(storDetails.reviews[0].averate_rating > 4 && storDetails.reviews[0].averate_rating < 5)" [ngClass]="{'checked' : (storDetails.reviews[0].averate_rating > 4 && storDetails.reviews[0].averate_rating < 5) , 'fa-star-half' : (storDetails.reviews[0].averate_rating > 4 && storDetails.reviews[0].averate_rating < 5) }"></span>
                        </div>
                    </div>
                    <label> <strong>{{storDetails.reviews[0].averate_rating }}</strong> Google Ratings </label>
                </div>
            </div>
        </div>
    </div>
</section>
<div *ngIf="isThankYouPage" class="thank-you-main-div mt-5">
    <div class="thankYoumsg">
        <h3>Thank You!</h3>
        <h6 class="mt-3" *ngIf="userName && userName.length <= 20">Thank you for your interest in Dell{{ userName && userName.length > 0 ? ", ": "."}} {{userName}}{{ userName && userName.length > 0 ? ".": ""}}</h6>
        <div class="px-15" *ngIf="userName.length > 20" [innerHTML]="userName"></div>
        <p class="mt-2 mb-5 h2">Our Dell representative will contact you soon.</p>
    </div>
</div>
<section class="storeDetailWrap">
    <div class="container">
        <div class="backBtnwrap" *ngIf="!isThankYouPage">
            <span class="backBtn" on-click="goBack()"> Back to Store Listing </span>
        </div>
        <div class="storeDetail">
            <app-store-gallery *ngIf="storDetails" [storDetails]="storDetails"></app-store-gallery>
             <div class="googleReview" *ngIf="storDetails && storDetails.reviews.length > 0">
                <div class="grHead">
                    <h2 class="boldLIght towLineHead">
                        <strong><span>Google</span></strong> Business Reviews
                    </h2>
                </div>

                <div class="googleReviewSlide">
                    <div class="grList" *ngIf="storDetails && storDetails.reviews.length > 0">
                        <div class="grItem" *ngFor="let review of storDetails.reviews">
                            <div class="giHead">
                                <span class="giLeft">
                                    <h3 style="margin-bottom: auto;">{{review.display_Name}}</h3>
                                    <i>Posted on : {{review.crt_Dt | date: 'dd/MM/yyyy hh:mm a'}}</i>
                                </span>
                                <span class="starRating">{{review.star_Rating}}</span>
                            </div>
                            <div class="reviws">
                                <p>{{review.comment}}</p>
                            </div>
                        </div>

                    </div>

                    <div class="swiper-scrollbar"></div>
                </div>
            </div>
            <div class="enqueryForm" id="getInTouch" *ngIf="!isThankYouPage">
                <div class="eqFwrap">
                    <h2 class="boldLIght towLineHead">
                        <strong><span>Enquiry Get A call</span></strong> Please fill in your details below and our team
                        will get in touch with you.
                    </h2>
                   <form [formGroup]="enquiryForm">
                        <ul class="efListwrap">
                            <li>
                                <span>
                                    <label>Name</label>
                                    <input class="input" type="text" placeholder="Enter Name" formControlName="name" autocomplete="off"
                                        maxlength="100" />
                                </span>
                                <small class="error" *ngIf="submitted && myForm.name.errors?.required">
                                    <sup>*</sup>Enter your name
                                </small>
                                <small class="error" *ngIf="submitted && myForm.name.errors?.minlength">
                                    <sup>*</sup>Name must be 2 characters long
                                </small>
                                <small class="error" *ngIf="submitted && myForm.name.errors?.pattern">
                                    <sup>*</sup>Please enter a valid name
                                </small>
                            </li>
                            <li>
                                <span>
                                    <label>Mobile*</label>
                                    <input class="input" type="text" placeholder="+91" 
                                    (input)="maxLengthTen($event)" inputmode="numeric" autocomplete="off"
                                     maxlength="10"
                                        formControlName="mobileNo"  />
                                    <small class="error" *ngIf="submitted && myForm.mobileNo.errors?.required">
                                        <sup>*</sup>Please enter your Mobile number
                                    </small>
                                    <small class="error" *ngIf="submitted && myForm.mobileNo.errors?.minlength">
                                        <sup>*</sup>Please enter 10 digit Mobile Number
                                    </small>
                                </span>
                            </li>

                            <li>
                                <span>
                                    <label>Pincode*</label>
                                    <input class="input" type="text" placeholder="Pincode"  appOnlynumber
                                        formControlName="pincode" maxlength="6"
                                        (input)="maxLengthSix($event)" inputmode="numeric" autocomplete="off"
                                         />
                                    <small class="error" *ngIf="submitted && myForm.pincode.errors?.required">
                                        <sup>*</sup>Please enter your Pincode
                                    </small>
                                    <small class="error" *ngIf="submitted && myForm.pincode.errors?.minlength">
                                        <sup>*</sup>Please enter 6 digit Pincode
                                    </small>
                                </span>
                            </li>
                            <li>
                                <span>
                                    <label>Email</label>
                                    <input class="input" type="text" placeholder="Enter Email" formControlName="email"
                                        maxlength="100" autocomplete="off" />
                                    <small class="error" *ngIf="submitted && myForm.email.errors?.required">
                                        <sup>*</sup>Enter your email
                                    </small>
                                    <small class="error" *ngIf="submitted && myForm.email.errors?.pattern">
                                        <sup>*</sup>Please enter valid email
                                    </small>
                                </span>
                            </li>

                            <div class="sub">
                                <a href="javascript:void" class="gradientBtn formBtn" (click)=onSubmit($event,content)>{{submitText}}
                                    <img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=ev5teqd&ct=0:031y6qj&fmt=3"/>
                                </a>
                                <small></small>
                            </div>

                        </ul>
                    </form>

                    <!-- <div class="" id="dynamicForm"></div> -->
                    <p class="disclaimer">
                        <sup>*</sup> <em>By submitting this form, you agree to be contacted by Sales Representative from
                            Dell Technologies, its group of companies, or exclusive stores. For more details on our
                            information practices, see our Privacy Statement. You can unsubscribe at any time.</em>
                    </p>
                </div>
                <div class="thankYoumsg" style="display: none">
                    <h3>Thank You</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus iaculis.
                    </p>
                    <a href="#" class="crossBtn"></a>
                </div>
            </div>
           
            <div class="sotreListwrap" *ngIf="storeImages && storeImages.length > 0">
                <h2 class="boldLIght towLineHead">
                    <strong><span>Store</span></strong> The best way to buy the products you love.
                </h2>
                <ul class="storeList">
                    <li *ngFor="let store of storeImages" class="li">
                        <img [src]="store.src" alt="" style="margin-bottom: 15px;"/>
                        <h2>{{ store.heading }}</h2>
                        <p>{{ store.text }}</p>
                        <span *ngIf="store.price" [innerHTML]="store.price"></span>
                        <div class="btnwrap">
                            <a
                            (click)="app.getDataLayervalues(store, 'Get_in_touch_product')"
                                [href]="getMobileNumber(storDetails,store.vfn)" class="gradientBtn">Get in
                                Touch</a>
                        </div>
                    </li>

                </ul>
            </div>
            <app-faq *ngIf="!isThankYouPage"></app-faq>
        </div>
    </div>
</section>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="thankYoumsg">
        <button class="btn-close thankyou-btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        <h3 class="modal-title" id="modal-basic-title">Thank You</h3>

    </div>
    <div class="modal-body text-center">
        <p><strong>{{description}}</strong></p>
    </div>
</ng-template>